import { render, staticRenderFns } from "./RobotTemplate.vue?vue&type=template&id=abb0157e&scoped=true"
import script from "./RobotTemplate.vue?vue&type=script&lang=js"
export * from "./RobotTemplate.vue?vue&type=script&lang=js"
import style0 from "./RobotTemplate.vue?vue&type=style&index=0&id=abb0157e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb0157e",
  null
  
)

export default component.exports